import _ from 'lodash';
import OPERATORS from '../constants/operators';

const operatorMap = {
  [OPERATORS.STARTS_WITH]: (value, str) => _.startsWith(value, str),
  [OPERATORS.CONTAINS]: (value, str) => _.includes(value, str),
};

const freeTextSearch = (rowValue, operator, string) => !operatorMap[operator] || operatorMap[operator](
  rowValue && rowValue.toLowerCase(),
  string.toLowerCase(),
);

const textFilterMethod = (filter, row) => {
  const {
    operator,
    string,
    clearFilter,
    multiSelectValues,
  } = filter.value;
  if (clearFilter) {
    return true;
  }

  const rowValue = row[filter.id];
  const isRowValueArray = Array.isArray(rowValue);

  if (multiSelectValues && multiSelectValues.length) {
    if (isRowValueArray) {
      return !!_.find(multiSelectValues, (multiSelectValue) => rowValue.indexOf(multiSelectValue.value) > -1);
    }

    return !!_.find(multiSelectValues, { value: rowValue || null });
  }

  if (isRowValueArray) {
    return !!rowValue.find((value) => freeTextSearch(value, operator, string));
  }

  return freeTextSearch(rowValue, operator, string);
};

export default textFilterMethod;
